<template>
  <div>
    <div class="advance-search-modal">
      <div class="lv3-title-text">Filter</div>
      <div class="lv3-edit-form">
        <div class="half-input-wrapper">
          <div class="hiw-label">Nama Vendor</div>
          <div class="hiw-multiple">
            <input type="text" class="hiw-text" v-model="vendorName" placeholder="Nama Vendor" />
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">SIO</div>
          <div class="hiw-multiple">
            <label class="hiw-2-row"><input type="radio" value="1" v-model="chooseSio"
                style="margin-right: 10px" />Active</label>
            <label class="hiw-2-row"><input type="radio" value="0" v-model="chooseSio" style="margin-right: 10px" />Not
              Active</label>
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Pertambangan</div>
          <div class="hiw-multiple">
            <label class="hiw-2-row"><input type="radio" value="1" v-model="chooseMine"
                style="margin-right: 10px" />Inti</label>
            <label class="hiw-2-row"><input type="radio" value="0" v-model="chooseMine" style="margin-right: 10px" />Non
              Inti</label>
          </div>
        </div>

        <div class="half-input-wrapper">
          <div class="hiw-label">Nilai K3L</div>
          <div class="hiw-multiple">
            <label class="hiw-4s-row" v-for="(list, index) in k3lCategories" :key="index">
              <input type="checkbox" :value="list.id" v-model="chooseK3lScore" style="margin-right: 10px" />
              {{ list.desc }}
            </label>
          </div>
        </div>

        <div class="half-input-wrapper">
          <div class="hiw-label">Status</div>
          <div class="hiw-multiple">
            <!-- <label class="hiw-4s-row">
              <input
                type="checkbox"
                value="COMPLETE"
                v-model="chooseStatus"
                style="margin-right: 10px"
              />
              COMPLETE
            </label> -->
            <label class="hiw-4s-row">
              <input type="checkbox" value="NOT COMPLETE" v-model="chooseStatus" style="margin-right: 10px" />
              NOT COMPLETE
            </label>
          </div>
        </div>
        <div class="half-input-wrapper">
          <div class="hiw-label">Expire</div>
          <div class="hiw-multiple">
            <label class="hiw-4s-row">
              <input type="checkbox" value="Expired Soon" v-model="chooseExpire" style="margin-right: 10px" />
              Expired Soon
            </label>
            <label class="hiw-4s-row">
              <input type="checkbox" value="Expired" v-model="chooseExpire" style="margin-right: 10px" />
              Expired
            </label>
          </div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="runSearch()">CONFIRM</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
import moment from 'moment'
export default {
  data() {
    return {
      poScoreStart: 0,
      poScoreEnd: 0,
      spmScoreStart: 0,
      spmScoreEnd: 0,
      k3lStartDate: null,
      k3lEndDate: null,
      kplhStartDate: null,
      kplhEndDate: null,
      sioStartDate: null,
      sioEndDate: null,
      countries: [],
      choosedCountry: null,
      provinces: [],
      choosedProvince: null,
      cities: [],
      choosedCity: null,
      districs: [],
      choosedDistric: null,
      villages: [],
      choosedVillage: null,
      kbliList: [],
      k3lCategories: null,
      kplhCategories: null,
      periode: '',

      kbliShow: false,
      iujpShow: false,
      iujptlShow: false,
      sbujkShow: false,
      inubbmShow: false,
      siupalShow: false,
    }
  },
  created() {
    this.getCriteria()
  },
  computed: {
    vendorName: {
      get: function () {
        return this.$store.state.notifStore.vendorName
      },
      set: function (newValue) {
        this.$store.commit('notifStore/UPDATE_DATA', {
          name: 'vendorName',
          value: newValue,
        })
      },
    },
    chooseSio: {
      get: function () {
        return this.$store.state.notifStore.chooseSio
      },
      set: function (newValue) {
        this.$store.commit('notifStore/UPDATE_DATA', {
          name: 'chooseSio',
          value: newValue,
        })
      },
    },
    chooseMine: {
      get: function () {
        return this.$store.state.notifStore.chooseMine
      },
      set: function (newValue) {
        this.$store.commit('notifStore/UPDATE_DATA', {
          name: 'chooseMine',
          value: newValue,
        })

        if (newValue == 0) {
          this.$store.commit('notifStore/UPDATE_DATA', {
            name: 'choosedIujp',
            value: [],
          })
        }
      },
    },
    chooseK3lScore: {
      get: function () {
        return this.$store.state.notifStore.chooseK3lScore
      },
      set: function (newValue) {
        this.$store.commit('notifStore/UPDATE_DATA', {
          name: 'chooseK3lScore',
          value: newValue,
        })
      },
    },
    chooseStatus: {
      get: function () {
        return this.$store.state.notifStore.chooseStatus
      },
      set: function (newValue) {
        this.$store.commit('notifStore/UPDATE_DATA', {
          name: 'chooseStatus',
          value: newValue,
        })
      },
    },
    chooseExpire: {
      get: function () {
        return this.$store.state.notifStore.chooseExpire
      },
      set: function (newValue) {
        this.$store.commit('notifStore/UPDATE_DATA', {
          name: 'chooseExpire',
          value: newValue,
        })
      },
    },
  },
  watch: {
    choosedIujp(value) {
      if (value.length > 0) {
        this.$store.commit('notifStore/UPDATE_DATA', {
          name: 'chooseMine',
          value: 1,
        })
      } else {
        this.$store.commit('notifStore/UPDATE_DATA', {
          name: 'chooseMine',
          value: null,
        })
      }
    },
  },
  methods: {
    kbliShowBtn() {
      this.kbliShow = !this.kbliShow
    },
    iujpShowBtn() {
      this.iujpShow = !this.iujpShow
    },
    iujptlShowBtn() {
      this.iujptlShow = !this.iujptlShow
    },
    sbujkShowBtn() {
      this.sbujkShow = !this.sbujkShow
    },
    inubbmShowBtn() {
      this.inubbmShow = !this.inubbmShow
    },
    siupalShowBtn() {
      this.siupalShow = !this.siupalShow
    },
    showKbliEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addKbli',
        status: true,
      })
    },
    showIujpEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addIujp',
        status: true,
      })
    },
    showSbujkEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addSbujk',
        status: true,
      })
    },
    showIujptlEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addIujptl',
        status: true,
      })
    },
    showInuBbmEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addInuBbm',
        status: true,
      })
    },
    showSiupalEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addSiupal',
        status: true,
      })
    },
    async getCriteria() {
      try {
        const urlK3l = `${api}/api/v1/k3l-categories?page=1&limit=50`
        const urlKplh = `${api}/api/v1/kplh-categories?page=1&limit=50`

        const { data: k3l } = await axios({
          method: 'GET',
          url: urlK3l,
        })

        const { data: kplh } = await axios({
          method: 'GET',
          url: urlKplh,
        })

        this.k3lCategories = k3l.data
        this.kplhCategories = kplh.data
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async getKbli() {
      this.kbliList = await this.$getKbli()
    },
    async getCountry() {
      const url = `${api}/api/v1/negara?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.countries = data.data
      } catch (error) { }
    },
    async getProvince() {
      const url = `${api}/api/v1/provinsi?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.provinces = data.data
      } catch (error) { }
    },
    async getCity() {
      const url = `${api}/api/v1/kota?page=1&limit=1000&provinsi=${this.choosedProvince.id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.cities = data.data
      } catch (error) { }
    },
    async getDistric() {
      const url = `${api}/api/v1/kecamatan?page=1&limit=10000&kota=${this.choosedCity.id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.districs = data.data
      } catch (error) { }
    },
    async getVillage() {
      const url = `${api}/api/v1/kelurahan?page=1&limit=1000&kecamatan=${this.choosedDistric.id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.villages = data.data
      } catch (error) { }
    },
    closeModal() {
      const self = this
      this.$store.commit('notifStore/RESET_FILTER')
      self.$store.commit('notifStore/UPDATE_DATA', {
        name: 'search_modal',
        value: false,
      })
    },
    async resetFilter() {
      await this.$store.commit('notifStore/RESET_FILTER')
    },
    async runSearch() {
      let query = {
        vendorName:
          this.vendorName && this.vendorName !== ''
            ? `&search=${this.vendorName}`
            : '',

        tambang: this.chooseMine ? `&pertambangan_inti=${this.chooseMine}` : '',
        sio: this.chooseSio ? `&sio=${this.chooseSio}` : '',
        k3lScore:
          this.chooseK3lScore.length > 0
            ? this.paramsFormatter('k3l_score', this.chooseK3lScore)
            : '',
        statusLegal:
          this.chooseStatus.length > 0
            ? this.paramsFormatter('statusLegal', this.chooseStatus)
            : '',
        expireLegal:
          this.chooseStatus.length > 0
            ? this.paramsFormatter('expireLegal', this.chooseExpire)
            : '',
      }

      // await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      await this.$store.dispatch('notifStore/checkDocument')
      await this.resetFilter()
      this.$store.commit('notifStore/UPDATE_DATA', {
        name: 'search_modal',
        value: false,
      })
    },
  },
}
</script>
<style></style>
